import styled from 'styled-components';
import { Row } from 'components/Layout/Grid';

export const LastHitsArea = styled(Row).attrs({
  className: "flex-1 flex-row mb-5"
})`
  gap: 30px;
  flex-wrap: wrap;

  > div > div {
    gap: 5px;
    display: flex;
    padding: 15px 7px;
    flex-direction: column;
  }
`;